// ES lang
export default {
    username: "Nombre de usuario",
    password: 'Contraseña',
    email: 'Correo electrónico',
    name: 'Nombre',
    first_name: 'Nombres',
    last_name: 'Apellido',
    institute: 'Institución',
    position: 'Cargo',
    loading: 'Cargando',
    login: 'Iniciar sesión',
    copyright: 'Todos los derechos reservados',
    optional: 'Opcional',
    description: 'Descripción',
    delete: 'Eliminar',
    submit: 'Enviar',
    save: 'Guardar',
    cancel: 'Cancelar',
    icon: 'Ícono',
    order: 'Orden',
    subject: 'Asunto',
    body: 'Cuerpo',
    forms: {
        correct_form_errors: 'Errores'
    },
    validation: {
        required: 'El campo {attribute} es requerido.',
        email: "El campo {attribute} no contiene un email válido",
        minLength: "Campo {attribute} no tiene el mínimo de caracteres",
        sameAsPassword: "Las contraseñas deben ser idénticas"
    },
    expired_session: 'Tu sesión ha expirado, inicia sesión nuevamente',
    login_required: 'Sesión finalizada',
    login_section: {
        init_msg: "Ingresa nombre de usuario y contraseña para acceder al sitio.",
        forgot_your_password: "¿Olvidaste tu contraseña?",
        dont_have_an_account: "¿No tienes una cuenta?",
        sign_up: "Regístrate"
    },
    company_info_section: {
        company_name: 'Nombre de la compañía',
        phone_number: 'Número de teléfono',
        primary_color: 'Color primario',
        whatsapp_number: 'Whatsapp',
        contact_email: 'Email de contacto',
        support_email: 'Email de soporte',
        instagram_name: 'Nombre usuario Instagram',
        instagram_url: 'URL Instagram',
        facebook_name: 'Nombre Facebook',
        facebook_url: 'URL Facebook'
    },
    projects: {
        page_title: 'Proyectos',
        name: {
            name: 'Nombre proyecto'
        },
        comments: {
            name: 'Comentarios'
        }
    }
}